module.exports = __webpack_public_path__ + "static/media/room-08.dd0763ec.jpg";